import { QUERY_KEYS } from 'api/query-keys';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { sharedPaymentService } from 'api/services';
import { Site } from 'shared/hooks';

type UnblockPaymentMutationContext = { site: Site; paymentId: string };
type UnblockPaymentMutationOptions = UseMutationOptions<
  unknown,
  Error,
  UnblockPaymentMutationContext
>;
export const useUnblockPayment = (options?: UnblockPaymentMutationOptions) => {
  const mutationFn = async ({ site, paymentId }: UnblockPaymentMutationContext) =>
    await sharedPaymentService.unblockPayment(site, paymentId);
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation(mutationFn, {
    onSuccess: async (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.payments());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  });
};
